import React from 'react';
import Styles from './ProgressStepper.module.scss';
import { FiCheck } from 'react-icons/fi';

const STEPS = [
  { number: 1, title: 'Brand Overview', subtitle: 'Quick Start' },
  { number: 2, title: 'Brand Foundation', subtitle: 'Core Identity' },
  { number: 3, title: 'Website Analysis', subtitle: 'AI Insights' },
  { number: 4, title: 'Social Channels', subtitle: 'Platform Presence' },
  { number: 5, title: 'Content Training', subtitle: 'Voice & Style' },
  { number: 6, title: 'Audience', subtitle: 'Target Insights' },
  { number: 7, title: 'AI Settings', subtitle: 'Configuration' },
];

const ProgressStepper = ({ currentStep, variant = 'horizontal', onStepClick, brandId }) => {
  const isVertical = variant === 'vertical';

  const handleStepClick = (stepNumber) => {
    // Lock steps 2-7 if no brandId exists (Step 1 must be completed first)
    if (stepNumber > 1 && !brandId) {
      return; // Don't allow navigation
    }
    if (onStepClick) {
      onStepClick(stepNumber);
    }
  };

  return (
    <div className={`${Styles.container} ${isVertical ? Styles.vertical : ''}`}>
      <div className={`${Styles.stepsWrapper} ${isVertical ? Styles.verticalWrapper : ''}`}>
        {STEPS.map((step, index) => {
          const isLocked = step.number > 1 && !brandId;
          return (
            <React.Fragment key={step.number}>
            <div
              className={`${Styles.stepContainer} ${isVertical ? Styles.verticalStep : ''} ${isLocked ? Styles.locked : ''}`}
              onClick={() => handleStepClick(step.number)}
              style={isLocked ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
              title={isLocked ? 'Complete Step 1 first' : ''}
            >
              {/* Step Circle */}
              <div
                className={`${Styles.stepCircle} ${
                  currentStep > step.number
                    ? Styles.completed
                    : currentStep === step.number
                    ? Styles.active
                    : Styles.pending
                }`}
              >
                {currentStep > step.number ? (
                  <FiCheck className={Styles.checkIcon} />
                ) : (
                  <span className={Styles.stepNumber}>{step.number}</span>
                )}
              </div>

              {/* Step Text */}
              <div className={Styles.stepText}>
                <div className={Styles.stepTitle}>{step.title}</div>
                <div className={Styles.stepSubtitle}>{step.subtitle}</div>
              </div>
            </div>

            {/* Connector Line */}
            {index < STEPS.length - 1 && (
              <div
                className={`${Styles.connector} ${isVertical ? Styles.verticalConnector : ''} ${
                  currentStep > step.number ? Styles.connectorCompleted : ''
                }`}
              />
            )}
          </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressStepper;
